import { gql } from "@apollo/client";

export const FETCH_DOCUMENTS = gql`
  query Documents($pagination: PaginationInput, $search: String) {
    me {
      documents(pagination: $pagination, search: $search) {
        page
        pageSize
        count
        data {
          id
          name
          metadata {
            updatedAt
            createdAt
            contentType
          }
          link {
            authenticatedURL
            expiresAt
          }
        }
      }
      documentContentTypes
    }
  }
`;

export const DELETE_DOCUMENTS = gql`
  mutation DeleteDocument($documentName: String!) {
    deleteDocument(name: $documentName)
  }
`;

export const SHARE_DOCUMENT = gql`
  mutation ShareDocument($documentName: String!, $recipients: [String!]!) {
    shareDocument(name: $documentName, recipients: $recipients)
  }
`;
